import axios from 'axios';

// Human-readable file size, e.g. 2.4 MB, 512 KB, 900 B.
export function formatBytes(bytes) {
  if (bytes === null || bytes === undefined || bytes === '') return '';
  const b = Number(bytes);
  if (!Number.isFinite(b) || b <= 0) return '';
  const units = ['B', 'KB', 'MB', 'GB', 'TB'];
  let i = 0;
  let v = b;
  while (v >= 1024 && i < units.length - 1) { v /= 1024; i += 1; }
  const str = i === 0 ? String(Math.round(v)) : v.toFixed(1).replace(/\.0$/, '');
  return `${str} ${units[i]}`;
}

// Coerce an axios error's `detail` (string | FastAPI 422 array | object) to a string.
export function errMessage(e, fallback = 'Something went wrong') {
  const d = e?.response?.data?.detail;
  if (typeof d === 'string') return d;
  if (Array.isArray(d)) return d.map(x => (x && x.msg) ? x.msg : String(x)).join('; ') || fallback;
  if (d && typeof d === 'object' && d.msg) return d.msg;
  return e?.message || fallback;
}

// Multipart upload helper. Uses a bare axios call (NOT the shared `api` instance,
// whose default Content-Type: application/json would clobber the multipart
// boundary) so the browser sets `multipart/form-data; boundary=...` itself.
export function uploadDocument(formData, onUploadProgress) {
  const token = localStorage.getItem('token');
  return axios.post(
    `${process.env.REACT_APP_BACKEND_URL}/api/documents/upload`,
    formData,
    {
      headers: token ? { Authorization: `Bearer ${token}` } : {},
      onUploadProgress,
    },
  );
}
